import imgMail from '@pe-libs/react-components/build/assets/common/icons/mail.svg';
import PeImage from '@pe-libs/react-components/build/components/PeImage';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import PeContentLayout from '../PeContentLayout';
import useStyles from '../PeRegister/styles';
import messages from './messages';

const PeOnboardingError: FC = () => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();

  return (
    <PeContentLayout
      contentTitle={formatMessage(messages.errorTitle)}
      contentDesc={formatMessage(messages.errorDesc)}
      marketingTitle={formatMessage(messages.slogantitlestepError)}
      marketingDesc={formatMessage(messages.slogandescstepError)}
      backgroundName="bgGroup"
    >
      <div className={styles.icon}>
        <PeImage
          width={86}
          height={70}
          layout="fixed"
          alt={`${formatMessage(messages.altImgMail)}`}
          src={imgMail as string}
        />
      </div>
    </PeContentLayout>
  );
};

export default PeOnboardingError;
